import Dashboard from './Dashboard.vue';

export default [
  {
    name: 'user-home',
    path: '/',
    component: Dashboard,
  },
];
